<template>
<div class="nkn-cooperater">
    <div class="cooperater-row block-inner">
        <div class="common-sub-title">{{$t("about.partnerTitle")}}</div>
        <div class="partner-block block-content">
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/telecom2.png'" class="pic-partner-telecom2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/ONF2.png'" class="pic-partner-ONF2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/cryptic2.png'" class="pic-partner-cryptic2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/datapace2.png'" class="pic-partner-datapace2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/portal2.png'" class="pic-partner-portal2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/Block-VC.png'" class="pic-partner-Block-VC"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/NGC.png'" class="pic-partner-NGC"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/NodeCapital.png'" class="pic-partner-NodeCapital"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/String.png'" class="pic-partner-String"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/fenbushi.png'" class="pic-partner-fenbushi"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/arrington-XRP.png'" class="pic-partner-arrington-XRP"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/DFG.png'" class="pic-partner-DFG"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/OKEx-logo.png'" class="pic-partner-OKEx-logo"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/IF.png'" class="pic-partner-IF"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/JLAB.png'" class="pic-partner-JLAB"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/GENESIS.png'" class="pic-partner-GENESIS"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/Collinsatr.png'" class="pic-developer-Collinsatr"/>
            </div>
            <div class="partner-icon">
              <img v-lazy="'/static/img/about/partner/Iotex.png'" class="pic-partner-Iotex"/>
            </div>
            <div class="partner-icon">
              <img v-lazy="'/static/img/about/partner/Unetwork2.png'" class="pic-partner-Unetwork2"/>
            </div>
            <div class="partner-icon">
              <img v-lazy="'/static/img/about/partner/Dxchain2.png'" class="pic-partner-Dxchain2"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/NOIA.png'" class="pic-blockchain-NOIA"/>
            </div>
            <div class="partner-icon">
                <img v-lazy="'/static/img/about/partner/Bluzelle.png'" class="pic-blockchain-Bluzelle"/>
            </div>
          <div class="partner-icon">
            <img v-lazy="'/static/img/about/partner/Ankr.png'" class="pic-blockchain-ankr"/>
          </div>
          <div class="partner-icon">
            <img v-lazy="'/static/img/about/partner/Harmony.png'" class="pic-blockchain-harmony"/>
          </div>
          <div class="partner-icon">
            <img v-lazy="'/static/img/about/partner/Taxa.png'" class="pic-blockchain-taxa"/>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({
      lang: 'getLang'
    })
  }
}
</script>

<style lang="scss">
    .nkn-cooperater {
        padding: 0;
        margin: 0 auto;
        text-align: center;

        .common-sub-title{
            width: 1200px;
            margin: 0 auto;
            text-align: left;
            @media screen and (max-width: 768px){
                width: 345px;
                text-align: center;
            }
        }

        .cooperater-row {
            padding-top: 40px;
        }
        .block-inner {
            .block-content {
              display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 40px !important;
                @include common-inner();
                @media screen and (max-width: 768px) {
                    padding: 20px 0;
                }
            }
        }
        .block-inner:nth-child(even) {
            background-color: #ffffff;
        }
        .partner {
            &-block {
                padding: 40px 0;
                padding-bottom: 0;
            }

            &-icon {
                display: flex; justify-content: center;align-items: center;
                width: 11.7rem;
                height: 5.375rem;

                @media screen and (max-width: 768px) {
                    margin-top: 2rem;
                    line-height: 2rem;
                    width: 25%;
                    padding: 0 10px;
                    img {
                        width: 60px;
                        height: auto;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/about/nknPartner.vue